'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'print';
var width = 512;
var height = 512;
var aliases = [128424,128438,9113];
var unicode = 'f02f';
var svgPathData = 'M384 144l48 0 0-37.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L144 0C108.7 0 80 28.7 80 64l0 80 48 0 0-80c0-8.8 7.2-16 16-16l181.5 0c4.2 0 8.3 1.7 11.3 4.7l42.5 42.5c3 3 4.7 7.1 4.7 11.3l0 37.5zM368 368l0 96-224 0 0-96 224 0zM128 320c-17.7 0-32 14.3-32 32l0 16-48 0 0-112c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 112-48 0 0-16c0-17.7-14.3-32-32-32l-256 0zm288 96l64 0c17.7 0 32-14.3 32-32l0-128c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 384c0 17.7 14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPrint = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;